import { render } from "./ProfessionDirectionView.vue?vue&type=template&id=79afdf53&scoped=true"
import script from "./ProfessionDirectionView.vue?vue&type=script&lang=js"
export * from "./ProfessionDirectionView.vue?vue&type=script&lang=js"

import "./ProfessionDirectionView.vue?vue&type=style&index=0&id=79afdf53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79afdf53"]])

export default __exports__